import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Graphic } from 'src/app/models/obs/graphic';
import { GraphicService } from 'src/app/services/obs/graphic.service';
import { GraphicTypetypeService } from 'src/app/services/obs/graphictype.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserLogService } from 'src/app/services/user-log.service';
import { UploadfileService } from 'src/app/services/util/uploadfile.service';
import { urlEndPoint } from 'src/app/common';
import { Log } from 'src/app/models/user-log';
import { UtilLogService } from 'src/app/services/util/util-log.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';

@Component({
  selector: 'app-admgraphic-form',
  templateUrl: './admgraphic-form.component.html',
  styleUrl: './admgraphic-form.component.scss'
})
export class AdmgraphicFormComponent implements OnInit {

  form: FormGroup;
  graph: Graphic = null;

  edit: boolean = false;
  idtier3Selected: number = null;
  uploatedFile: File;
  filename: string = null;
  isUploadDir: boolean = false;
  URL: string = urlEndPoint;

  isBlockedTier3: boolean = false;

  constructor(
    private t3Service: Tier3Service,
    private router: Router,
    private graphS: GraphicService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private uploadS: UploadfileService,
    private utilLogservice: UtilLogService,
    private tokenStorage: TokenStorageService,
    private tgS: GraphicTypetypeService

  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.createForm();
    this.getGraph(params);
    this.getGraphicsType();
  }


  verifiedImgDirectory() {
    if (this.graph.urldata != null) {
      if (this.graph.urldata.substring(1, 7) == 'upload') {
        this.isUploadDir = true;
      } else {
        this.isUploadDir = false;
      }
    }
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idtier3: [null],
      idgraphictype: ['', Validators.required],
      numeration: [],
      title: [],
      note: [],
      urldata: [],
      externalframe: [],
      order: ['', Validators.required],
      isresponsive: [false],
      touchedBy: [''],
      status: []
    })
  }

  flagGrphicOrimagen: number = 0;/* Bandera para controlar activacion o desactivacion de campo datawrapper */
  getGraph(params: any) {
    if (params.id) {
      this.graphS.getOne(params.id).subscribe({
        next: res => {
          this.graph = res['data'];
          this.idtier3Selected = this.graph.idtier3;
          this.getIsBlockedTier3(this.idtier3Selected);
          /*    this.flagGrphicOrimagen = this.graph.idgraphictype */
          this.verifiedImgDirectory();
          this.loadData();
          this.edit = true;
        },
        error: err => console.error(err)
      });
    } else if (params.idtier3) {
      this.idtier3Selected = params.idtier3;
      this.getIsBlockedTier3(this.idtier3Selected);
      this.edit = false;
    }
  }

  loadData() {
    this.form.reset(this.graph);
  }

  onFileChange(e) {
    this.uploatedFile = e.target.files;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.form.get('urldata').setValue(e.target['result']);
    };
    reader.readAsDataURL(this.uploatedFile[0]);
  }

  cancel() {
    this.router.navigate(['/adm/grafico/list/' + this.idtier3Selected]);
  }


  save() {
    if (this.form.invalid) {
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      (this.uploatedFile != null) ? this.onUpload() : this.saveOrUpdate();
    }
  }

  saveOrUpdate() {
    this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
    this.router.navigate(['/adm/grafico/list']);
  }

  onUpload() {
    let formData = new FormData();
    formData.append("uploads", this.uploatedFile[0], this.uploatedFile[0].name);
    this.uploadS.uploadFile(formData).subscribe((res) => {
      this.filename = res['filename'];
      this.saveOrUpdate();
    });
  }

  dataLog = {};
  create(graph: Graphic) {
    delete graph.id;
    graph.idtier3 = +this.idtier3Selected;
    graph.touchedBy = this.tokenStorage.getUser().nombre;
    graph.urldata = '/uploads/' + this.filename;
    this.graphS.create(graph).subscribe({
      next: res => {
        // Crear el log de actividad del usuario
        if (res) this.utilLogservice.createLog(res['data'], 'creación', 'graficos');
        this.router.navigate(['/adm/grafico/list/' + this.idtier3Selected]);
      },
      error: err => console.error(err)
    })
  }

  update(id: string, graph: Graphic) {
    const data = { ...graph };
    delete graph.id;
    graph.touchedBy = this.tokenStorage.getUser().nombre;
    if (this.filename) {
      graph.urldata = '/uploads/' + this.filename;
    }
    this.graphS.update(id, graph).subscribe({
      next: res => {
        // Crear el log de actividad del usuario
        if (res) this.utilLogservice.createLog(data, 'edición', 'graficos');
        this.router.navigate(['/adm/grafico/list/' + this.idtier3Selected]);
      },
      error: err => console.error(err)
    });
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }
  /* Cargar data de tematic para el combo */
  typeGraphics: any;
  getGraphicsType() {
    this.tgS.getAllActive().subscribe({
      next: res => {
        this.typeGraphics = res['data'];
      },
      error: err => {
        console.log(err['msg']);
      }
    });
  }
  /* Escucha los cambios del combo select */
  onChange(val) {
    this.flagGrphicOrimagen = val.value;
  }

  getIsBlockedTier3(id: number) {
    this.t3Service.idT3blocked(id).subscribe({
      next: res => { this.isBlockedTier3 = res['isBlocked']; },
      error: err => { console.log(err); }
    })
  }
}
